import { ChangeDetectionStrategy, Component, computed, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SidePanelContentDirective } from '@app/+authenticated/shared/app-side-panel/side-panel-content.directive';
import { SidePanelHeaderComponent } from '@app/+authenticated/shared/app-side-panel/side-panel-header.component';
import { BookACallFooterComponent } from '@app/+onboarding/components/book-a-call-footer/book-a-call-footer.component';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { getAuthenticatedUser } from '@reducers/orm/employee/employee.selectors';
import { ButtonComponent } from '@sb/ui/button';
import { ChecklistContentComponent, ChecklistProgressHeadingComponent } from '@sb/ui/checklist';
import { ProgressBarModel } from '@sb/ui/progress-bar';
import { OnboardingChecklistService } from '@shared/onboarding/onboarding-checklist.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'checklist-panel',
  templateUrl: './checklist-panel.component.html',
  imports: [
    SidePanelHeaderComponent,
    SidePanelContentDirective,
    TranslatePipe,
    BookACallFooterComponent,
    ChecklistContentComponent,
    ChecklistProgressHeadingComponent,
    ButtonComponent,
  ],
})
export class ChecklistPanelComponent {
  #store = inject(Store);
  #checklistService = inject(OnboardingChecklistService);
  #destroyRef = inject(DestroyRef);
  #authUser = this.#store.selectSignal(getAuthenticatedUser);
  checklist = this.#checklistService.checklist;
  showFooter = computed(() => this.checklist()?.showFooter);
  items = computed(() => this.checklist()?.items ?? []);
  progress = computed<ProgressBarModel>(() => ({
    level: this.checklist()?.progress ?? 0,
    theme: 'green',
  }));
  title = computed(() =>
    this.#checklistService.getChecklistTitle(this.checklist()?.progress ?? 0, {
      name: this.#authUser()?.first_name,
    }),
  );

  dismissChecklist() {
    void this.#checklistService.dismiss().pipe(takeUntilDestroyed(this.#destroyRef)).subscribe();
  }
}
